import { BlockTypeConsts } from './BlockTypeConsts';
import { BlockType } from './../../@types/BlockType';
import { utils } from '../other/BlocklyUtils';
import { GlobalImport } from '../../utils/GlobalImport';
const Blockly = GlobalImport.getBlockly();

export class ShapeSettings {
  static ATTR = 'ATTR';
  static IN = 'IN';
  static COLOUR = 'COLOUR';

  static setSceneStartShape(block: BlockType): void {
    Blockly.BlockSvg.START_HAT = true;
    // 属性のスタイル
    block.setPreviousStatement(false);
    // 次のステートメントを許可するか
    block.setNextStatement(false);
    // アウトプットの凸を出すか
    block.setOutput(false);
    // インライン化
    block.setInputsInline(false);
  }

  static setAttributeShape(block: BlockType): void {
    // ブロックを丸くする
    block.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
    // 属性のスタイル
    block.setPreviousStatement(false);
    // 次のステートメントを許可するか
    block.setNextStatement(false);
    // アウトプットの凸を出すか
    block.setOutput(true, 'Attribute');
    // インライン化
    block.setInputsInline(true);
  }

  static setElementShape(block: BlockType): void {
    // 前のイベントを追加するか（falseならハットがつく）
    Blockly.BlockSvg.START_HAT = true;
    block.setPreviousStatement(true);
    // 属性のスタイル
    block.setPreviousStatement(true);
    // 次のステートメントを許可するか
    block.setNextStatement(true);
    // アウトプットの凸を出すか
    block.setOutput(false);
    // インライン化
    block.setInputsInline(false);
  }

  static setElementWithSubBlockShape(block: BlockType): void {
    // 前のイベントを追加するか（falseならハットがつく）
    Blockly.BlockSvg.START_HAT = true;
    // 属性のスタイル
    block.setPreviousStatement(true);
    // 次のステートメントを許可するか
    block.setNextStatement(true);
    // アウトプットの凸を出すか
    block.setOutput(false);
    // インライン化
    block.setInputsInline(true);
  }

  static setValueShape(block: BlockType): void {
    // ブロックを丸くする
    block.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);

    // 属性のスタイル
    block.setPreviousStatement(false);
    // 次のステートメントを許可するか
    block.setNextStatement(false);
    // アウトプットの凸を出すか
    block.setOutput(true, 'Colour');
    // インライン化
    block.setInputsInline(true);
  }
  static setOperatorBoolShape(block: BlockType): void {
    block.setOutputShape(Blockly.OUTPUT_SHAPE_HEXAGONAL);
    block.setOutput(true, 'Boolean');
  }

  static addAttributeOfSceneStartInput(block: BlockType): void {
    block.appendValueInput(this.ATTR).setCheck(['SceneAttribute', 'AnyAttribute']);
  }

  static addAttributeInput(block: BlockType): void {
    block.appendValueInput(this.ATTR);
  }

  static addColorInput(block: BlockType): void {
    block.appendValueInput(this.COLOUR).setCheck('Colour');
  }

  static addStatementInput(block: BlockType): BlockType {
    return block.appendStatementInput(this.IN);
  }

  static getWhiteColorInputValueXML(): HTMLElement {
    const value = document.createElement('value');
    value.setAttribute('name', this.COLOUR);
    const shadow = document.createElement('shadow');
    shadow.setAttribute('type', 'color_value_v2');
    const field = document.createElement('field');
    field.setAttribute('name', this.COLOUR);
    field.appendChild(document.createTextNode('#FFFFFF'));
    shadow.appendChild(field);
    value.appendChild(shadow);
    return value;
  }

  static getColorInputValueXML(): HTMLElement {
    const value = document.createElement('value');
    value.setAttribute('name', this.COLOUR);

    const shadow = document.createElement('shadow');
    shadow.setAttribute('type', 'color_value_v2');

    const field = document.createElement('field');
    field.setAttribute('name', this.COLOUR);
    field.appendChild(document.createTextNode(utils.randomColour()));

    shadow.appendChild(field);
    value.appendChild(shadow);
    return value;
  }

  static setVR3Fields(block: BlockType, type = 'position', x: number, y: number, z: number): void {
    const fieldX = new Blockly.FieldTextInput(`${x}`);
    const fieldY = new Blockly.FieldTextInput(`${y}`);
    const fieldZ = new Blockly.FieldTextInput(`${z}`);

    block
      .appendDummyInput()
      .appendField('X')
      .appendField(fieldX, type + '-x')
      .appendField('Y')
      .appendField(fieldY, type + '-y')
      .appendField('Z')
      .appendField(fieldZ, type + '-z');
  }

  static setTitleField(block: BlockType, title: string): void {
    block.appendDummyInput().appendField(title);
  }

  static setIdField(block: BlockType): void {
    const fieldId = new Blockly.FieldTextInput(utils.IDConst);
    block.appendDummyInput().appendField('ID:').appendField(fieldId, 'id');
  }

  static setNamedField(name:string,fieldId:string,value:string,block: BlockType): void {
    const field = new Blockly.FieldTextInput(value);
    block.appendDummyInput().appendField(name + ':').appendField(field, fieldId);
  }


  static getDummyInput(block: BlockType): any {
    return block.appendDummyInput();
  }

  static getVR3LabelName(type): any {
    const label: { text1: string; text2: string } = { text1: '', text2: '' };

    switch (type) {
      case 'position':
        label.text1 = '位置';
        label.text2 = '移動';
        break;
      case 'scale':
        label.text1 = '大きさ';
        label.text2 = '拡大';
        break;
      case 'rotation':
        label.text1 = '回転';
        label.text2 = '回転';
        break;
    }
    return label;
  }

  /**
   * items : [ [title , value] , [title , value]]
   */
  static getDropDown(items: any[]): any {
    const fieldDD = new Blockly.FieldDropdown(items);
    return fieldDD;
  }
}
